import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LodgxToRoomexFallbackInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const originalUrl = req.url;
    
    const targetUrl = this.mapLodgxToRoomexUrl(originalUrl);

    if (!targetUrl) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 504) {
          const retryReq = req.clone({ url: targetUrl });
          console.error(`[504] Retrying with fallback domain: ${retryReq.url}`);
          return next.handle(retryReq);
        }
        return throwError(() => error);
      })
    );
  }

  private mapLodgxToRoomexUrl(url: string): string | null {
    const mappings = [
      { from: 'staypi.dev.lodgx.io', to: 'rxwebapi.roomex.co' },
      { from: 'staypi.stg.lodgx.io', to: 'rxwebapi.roomex.io' },
      { from: 'staypi.lodgx.io',     to: 'rxwebapi.roomex.com' },
    ];

    for (const { from, to } of mappings) {
      if (url.includes(from)) {
        return url.replace(from, to);
      }
    }

    return null;
  }
}